import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, AppBar, Toolbar, IconButton, Drawer, List, ListItem, ListItemText, ListItemIcon, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home'; // Ícono de la casita
import PersonIcon from '@mui/icons-material/Person'; // Ícono de la persona
import KebabDiningIcon from '@mui/icons-material/KebabDining';
import CloseIcon from '@mui/icons-material/Close';
import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import ReorderIcon from '@mui/icons-material/Reorder';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import StoreIcon from '@mui/icons-material/Store';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import ReceiptIcon from '@mui/icons-material/Receipt';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ErrorIcon from '@mui/icons-material/Error';
import { registrarAccion, isAuthenticated } from '../services/api.js';
import './estilos.css';

export const MenuInicial = () => {
  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const username = userData?.username;
  const perfil = userData?.perfil;
  const auditaroperaciones = userData?.auditaroperaciones;
  const usuarioid = userData?.usuarioid;
  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    //console.log("entre a menu inicial");
    const autenticado = isAuthenticated();
    if (autenticado===false) {
      navigate("/login");
    }
  }, [navigate]);

  const handleNavigation = async (destination) => {
    // Llamada a la API para registrar la acción de navegación
    if (Number(auditaroperaciones) === 1) {
      await registrarAccion(usuarioid, ` a ${destination}`);
    }
    // Navegación a la URL especificada
    navigate(destination);
  };

  return (
    <div className="miDiv">
      <AppBar position="static" style={{ backgroundColor: '#D72441' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
            <MenuIcon />
          </IconButton>
          <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <Button variant="text" onClick={() => handleNavigation("/dashboard")} style={{ color: '#ffffff' }}>
                <Tooltip title="Inicio"><HomeIcon /></Tooltip>
              </Button>
              {Number(perfil) === 1 && (
                <Button variant="text" onClick={() => handleNavigation("/userList")} style={{ color: '#ffffff' }}>
                  <Tooltip title="Usuarios"><PersonIcon /></Tooltip>
                </Button>
              )}
              {(Number(perfil) === 1 || Number(perfil) === 2) && (
                <>
                  <Button variant="text" onClick={() => handleNavigation("/productoList")} style={{ color: '#ffffff' }}>
                    <Tooltip title="Productos"><ArtTrackIcon /></Tooltip>
                  </Button>
                  <Button variant="text" onClick={() => handleNavigation("/productoOrdenar")} style={{ color: '#ffffff' }}>
                    <Tooltip title="Ordenar Productos"><ReorderIcon /></Tooltip>
                  </Button>
                  <Button variant="text" onClick={() => handleNavigation("/Carta")} style={{ color: '#ffffff' }}>
                    <Tooltip title="Carta"><PictureAsPdfIcon /></Tooltip>
                  </Button>
                  <Button variant="text" onClick={() => handleNavigation("/sucursalesList")} style={{ color: '#ffffff' }}>
                    <Tooltip title="Sucursales"><StoreIcon /></Tooltip>
                  </Button>
                  <Button variant="text" onClick={() => handleNavigation("/CuponesList")} style={{ color: '#ffffff' }}>
                    <Tooltip title="Cupones"><ReceiptIcon /></Tooltip>
                  </Button>
                  <Button variant="text" onClick={() => handleNavigation("/pedidosList")} style={{ color: '#ffffff' }}>
                  <Tooltip title="Pedidos"><KebabDiningIcon /></Tooltip>
                </Button>
                </>
              )}

              {(Number(perfil) === 3) && (
                <>
                  
                  <Button variant="text" onClick={() => handleNavigation("/pedidosList")} style={{ color: '#ffffff' }}>
                  <Tooltip title="Pedidos"><KebabDiningIcon /></Tooltip>
                </Button>
                </>
              )}
              
              {Number(perfil) === 1 && (
                <>
                  
                  <Button variant="text" onClick={() => handleNavigation("/UsuarioAccionesList")} style={{ color: '#ffffff' }}>
                    <Tooltip title="Usuarios acciones"><CleaningServicesIcon /></Tooltip>
                  </Button>
                  <Button variant="text" onClick={() => handleNavigation("/AuditoriaList")} style={{ color: '#ffffff' }}>
                    <Tooltip title="Auditoría de cambios"><VerifiedUserIcon /></Tooltip>
                  </Button>

                  <Button variant="text" onClick={() => handleNavigation("/ErroresList")} style={{ color: '#ffffff' }}>
                    <Tooltip title="Errores"><ErrorIcon /></Tooltip>
                  </Button>
                </>
              )}
            </div>
            
            <Button variant="text" onClick={() => handleNavigation("/logout")} style={{ color: '#ffffff' }}>
              <Tooltip title="Cerrar sesión"><CloseIcon /></Tooltip>
            </Button>
          </div>
        </Toolbar>
      </AppBar>

      <Drawer anchor="left" open={open} onClose={handleDrawerClose}>
        <div style={{ width: 250 }}>
          <List>
            <ListItem  onClick={() => handleNavigation("/dashboard")}>
              <ListItemIcon><HomeIcon /></ListItemIcon>
              <ListItemText primary="Inicio" />
            </ListItem>
            {Number(perfil) === 1 && (
              <ListItem  onClick={() => handleNavigation("/userList")}>
                <ListItemIcon><PersonIcon /></ListItemIcon>
                <ListItemText primary="Usuarios" />
              </ListItem>
            )}
            {(Number(perfil) === 1 || Number(perfil) === 2) && (
              <>
                <ListItem  onClick={() => handleNavigation("/productoList")}>
                  <ListItemIcon><ArtTrackIcon /></ListItemIcon>
                  <ListItemText primary="Productos" />
                </ListItem>
                <ListItem  onClick={() => handleNavigation("/productoOrdenar")}>
                  <ListItemIcon><ReorderIcon /></ListItemIcon>
                  <ListItemText primary="Ordenar Productos" />
                </ListItem>
                <ListItem  onClick={() => handleNavigation("/Carta")}>
                  <ListItemIcon><PictureAsPdfIcon /></ListItemIcon>
                  <ListItemText primary="Carta" />
                </ListItem>
              </>
            )}
     

            {(Number(perfil) === 1 || Number(perfil) === 2) && (
                 <>
              

              <ListItem  onClick={() => handleNavigation("/sucursalesList")}>
              <ListItemIcon><StoreIcon /></ListItemIcon>
              <ListItemText primary="Sucursales" />
              </ListItem>
              <ListItem  onClick={() => handleNavigation("/CuponesList")}>
              <ListItemIcon><ReceiptIcon /></ListItemIcon>
              <ListItemText primary="Cupones" />
              </ListItem>
              <ListItem  onClick={() => handleNavigation("/pedidosList")}>
                <ListItemIcon><KebabDiningIcon /></ListItemIcon>
                <ListItemText primary="Pedidos" />
              </ListItem>
              </>
            )}


            {Number(perfil) === 1  && (
              <>
               
                <ListItem  onClick={() => handleNavigation("/UsuarioAccionesList")}>
                  <ListItemIcon><CleaningServicesIcon /></ListItemIcon>
                  <ListItemText primary="Usuarios acciones" />
                </ListItem>
                <ListItem  onClick={() => handleNavigation("/AuditoriaList")}>
                  <ListItemIcon><VerifiedUserIcon /></ListItemIcon>
                  <ListItemText primary="Auditoría de cambios" />
                </ListItem>

                <ListItem  onClick={() => handleNavigation("/ErroresList")}>
                  <ListItemIcon><ErrorIcon /></ListItemIcon>
                  <ListItemText primary="Errores" />
                </ListItem>
              </>
            )}
            <ListItem  onClick={() => handleNavigation("/logout")}>
              <ListItemIcon><CloseIcon /></ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </List>
        </div>
      </Drawer>
    </div>
  );
};
